import { useEffect, useState } from "react";

// Shared PWA install-prompt capture — one global listener, any component can prompt.
let deferred = null;
let installedFlag = false;
const listeners = new Set();
const notify = () => listeners.forEach((fn) => fn());

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    installedFlag = true;
    deferred = null;
    notify();
  });
}

export const useInstallPrompt = () => {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return {
    canInstall: !!deferred && !installedFlag,
    installed: installedFlag,
    promptInstall: async () => {
      if (!deferred) return false;
      deferred.prompt();
      await deferred.userChoice;
      deferred = null;
      notify();
      return true;
    },
  };
};
